// @ts-nocheck 9ef86a2e
import * as addPanel from '#packages/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['design_section_label_explore_image'],
      sections: [addPanel.sections.getSections().image.imageStyleSection],
    };
  },
};
